angular.module('ikeweb.spike.measure').directive('photoMeasure', ['functional', '$timeout', 'spikeImageService', 'billingService',
    function(functional, $timeout, spikeImageService, billingService) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                imageElement: '=',
                photoMeasureBuilder: '=',
                canCorrectPerspective: '='
            },
            link: function($scope, $element) {
                // Used to hide flash of unstyled content during load
                $scope.ready = false;

                var element = $element.get(0);
                var mainImage = element.querySelector('.PhotoMeasure-image');
                var container = element.querySelector('.PhotoMeasure-svgWrapper');
                var observer;



                function buildPhotomeasure(imageEl) {
                    return spikeImageService.setImageSrc(mainImage, imageEl.src)
                        .then(function() {
                            return $scope.photoMeasureBuilder
                                .withImgElement(mainImage)
                                .withSVGElement(container)
                                .build()
                                .then(function(photoMeasure) {
                                    $scope.ready = true;

                                    var debouncedUpdate = functional.debounce(photoMeasure.update, 20, $timeout);

                                    $(window).resize(debouncedUpdate);

                                    observer = new window.MutationObserver(debouncedUpdate)
                                        .observe(element, {
                                            attributes: true,
                                            attributeFilter: ['style']
                                        });

                                    photoMeasure.update();

                                    $scope.$on('$destroy', photoMeasure.destroy);
                                });
                        });
                }

                $scope.$watch('imageElement', function(imageElement) {
                    if (imageElement) {
                        buildPhotomeasure(imageElement);
                    }
                });

                $scope.$on('$destroy', function() {
                    if (observer) {
                        observer.disconnect();
                    }
                });
            },
            template: '<div ng-show="ready" class="PhotoMeasure"><img class="PhotoMeasure-image"></img><div class="PhotoMeasure-svgWrapper"></div></div>'
        };
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/spike/measure/photo-measure/photo.measure.directive.js
// module id = 570
// module chunks = 0